import { render, staticRenderFns } from "./EscalaAgendaShow.vue?vue&type=template&id=559dfa7c&"
import script from "./EscalaAgendaShow.vue?vue&type=script&lang=js&"
export * from "./EscalaAgendaShow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports